import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=b93a9798&lang=pug"
import script from "./SendMailModal.vue?vue&type=script&lang=ts"
export * from "./SendMailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports